import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ConsumidorModel, ConsumidorService } from '../../../restrito/consumidor/shared';
import { LoginService } from '../../../restrito/consumidor/shared/login.service';
import { PaginatedList, SituacaoSorteioModel, SorteioModel, TipoSorteioModel } from '../../../shared';
import { FiltroBuscaPaginacao } from '../../../shared/filter/filtro-busca-paginacao';
import { SorteioService } from '../shared/sorteio.service';
import { DetalheSorteioTipoSituacoesModel } from './../../../shared/model/detalhe-sorteio-tipo-situacoes.model';
import { DetalheSorteioTipoModel } from './../../../shared/model/detalhe-sorteio-tipo.model';
import { FiltroListarSorteiosPorTipoESituacaoPortal } from '../../../shared/model/filtro-listar-sorteio-por-tipo-e-situacao';

@Component({
  selector: 'app-listar-sorteio',
  templateUrl: './listar-sorteio.component.html',
  styleUrls: ['./listar-sorteio.component.css']
})
export class ListarSorteioComponent implements OnInit {
  @ViewChild('t') public ngbTabTipoSorteio;
  @Input() public paginaSorteio: number;
  @Input() public tamanhoSorteio: number;

  public detalhesSorteios: Array<DetalheSorteioTipoModel>;

  public _tiposSorteio: Array<TipoSorteioModel>;
  public situacoesSorteio: Map<number, Array<SituacaoSorteioModel>>;
  public sorteios: Map<number, PaginatedList<SorteioModel>>;
  public totais: Map<number, number>;
  public excecoes: Array<number>;
  public consumidor: ConsumidorModel;
  public situacao = new SituacaoSorteioModel();

  public sorteio = new SorteioModel();

  public arrIconSorteio = new Array('icon-cupom-calendario.svg',
   'icon-cupom-ampulheta.svg',
   '',
   'icon-cupom-check.svg',
   'icon-cupom-ampulheta.svg');

  constructor(
    private readonly sorteioService: SorteioService,
    private readonly consumidorService: ConsumidorService,
    private readonly router: Router,
    private readonly loginService: LoginService
  ) {}

  public get tiposSorteio(): Array<TipoSorteioModel> {
    return this._tiposSorteio;
  }

  public set tiposSorteio(v: Array<TipoSorteioModel>) {
    this._tiposSorteio = v;
  }

  public totalRegistrosSorteio(tipo: number, situacao: number): number {
    return this.sorteios[`${tipo.toString()}${situacao.toString()}`].totalCount;
  }

  ngOnInit() {
    this.sorteio = new SorteioModel();

    this.paginaSorteio = 1;
    this.tamanhoSorteio = 10;

    this.tiposSorteio = new Array<TipoSorteioModel>();

    this.situacoesSorteio = new Map<number, Array<SituacaoSorteioModel>>();

    this.sorteios = new Map<number, PaginatedList<SorteioModel>>();
    this.totais = new Map<number, number>();

    this.excecoes = new Array<number>();
    this.excecoes.push(4);

    this.consumidor = this.consumidorService.getConsumidorModel();
    this.obterDetalhesSorteio();

    this.sorteioService.sorteiosChange.subscribe((data: { tipo: number; situacao: number; sorteios: PaginatedList<SorteioModel> }) => {
      if (data && this.detalhesSorteios) {
        this.detalhesSorteios.forEach(d => {
          d.situacoes.forEach(s => {
            if (
              d.codTipoSorteioPremiacaoConsumidor === data.tipo &&
              s.codSituacaoSorteioPremiacaoConsumidor === data.situacao &&
              s.sorteios
            ) {
              s.sorteios.list = data.sorteios.list;
            }
          });
        });
      }
    });

    this.getDetalhesSorteios();
  }

  private obterDetalhesSorteio() {
    this.sorteioService.detalhesSorteiosChange.subscribe(
      (data: Array<DetalheSorteioTipoModel>) => {
        let filtroCorrente = '';
        data.forEach(d => {
          d.situacoes.forEach(s => {
            filtroCorrente = `${d.codTipoSorteioPremiacaoConsumidor}${s.codSituacaoSorteioPremiacaoConsumidor}`;
            if (s.sorteios && s.sorteios.list) {
              this.totais[filtroCorrente] = s.sorteios.totalCount;
            } else {
              this.totais[filtroCorrente] = 0;
            }
          });
        });
        this.detalhesSorteios = data;
        if (this.sorteioService.abaTipoSorteioSelecionada) {
          this.ngbTabTipoSorteio.activeId = this.sorteioService.abaTipoSorteioSelecionada;
        }
      },
      erro => {
        console.log(erro.message);
      },
      () => {}
    );
  }

  public getDescricaoSituacao(situacao: DetalheSorteioTipoSituacoesModel) {
    if (situacao.codSituacaoSorteioPremiacaoConsumidor === 4) {
      return 'Realizado';
    }
    return situacao.desSituacaoSorteioPremiacaoConsumidor;
  }

  public escolherData(sorteio: SorteioModel) {
    if (sorteio.codSituacaoSorteioPremiacaoConsumidor === 3 || sorteio.codSituacaoSorteioPremiacaoConsumidor === 4) {
      return sorteio.dataRealizacaoSorteiroPremiacaoConsumidor;
    } else {
      return sorteio.dataPrevisaoSorteioPremiacaoConsumidor;
    }
  }

  public getDetalhesSorteios(): void {
    this.sorteioService.getDetalhesSorteios(new FiltroBuscaPaginacao(this.paginaSorteio, this.tamanhoSorteio));
  }

  public getTiposSorteio(): void {
    this.sorteioService.getTiposSorteio();
  }

  public detalhesSorteio(seqSorteioPremiacaoConsumidor: number): void {
    this.sorteioService.abaTipoSorteioSelecionada = this.ngbTabTipoSorteio.activeId;
    this.sorteioService.codSorteio = 0;

    if (this.loginService.isLogged()) {
      this.sorteioService.codSorteio = seqSorteioPremiacaoConsumidor;
      this.router.navigate([`/consumidor/detalhe_sorteio/${seqSorteioPremiacaoConsumidor}`]);
    } else {
      this.router.navigate([`/sorteios/detalhe/${seqSorteioPremiacaoConsumidor}`]);
    }
  }

  public gerarIdTab(tipo: number): string {
    return `tab-${tipo}`;
  }

  public pageChange(event: number, tipo: number, situacao: number): void {
    let filtro = new FiltroListarSorteiosPorTipoESituacaoPortal();
    filtro.tipoSorteio = tipo;
    filtro.situacaoSorteio = situacao;
    filtro.page = event;
    filtro.pageSize = this.tamanhoSorteio;
    this.sorteioService.getSorteiosPorSituacaoETipoPortal(filtro);
  }
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/listar-sorteio/listar-sorteio.component.ts